import { themed } from '@indeed/ifl-css';
import createResponsive from '../../utils/createResponsive.js';
import { TEXT_LEVELS } from '../Text/Text.js';

const HEADING_LEVELS = TEXT_LEVELS;
const marginBlockEnd = {
  1: 1,
  2: 1,
  3: 2,
  4: 2,
  5: 2,
  6: 4,
  7: 4,
  8: 4
};
const getVariant = createResponsive(level => `text.level${level}`);
const getMarginBlockEnd = createResponsive(level => marginBlockEnd[level]);
const baseProps = _ref => {
  let {
    level = 5
  } = _ref;
  return {
    marginBlockStart: 0,
    marginBlockEnd: getMarginBlockEnd(level),
    marginInlineStart: 0,
    marginInlineEnd: 0,
    color: "foreground.strong",
    fontWeight: "bold",
    fontFamily: "default",
    variant: getVariant(level)
  };
};

/**
 * @see https://experience.indeed.design/components/ids/heading
 */
const Heading = /*#__PURE__*/themed("h2", process.env.NODE_ENV === "production" ? {
  styleProps: ["level"],
  shouldForwardProp: prop => prop !== "level",
  target: "e1tiznh50"
} : {
  styleProps: ["level"],
  shouldForwardProp: prop => prop !== "level",
  target: "e1tiznh50",
  label: "Heading"
})(baseProps, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
Heading.displayName = "Heading";

export { HEADING_LEVELS, Heading };
